import "./style.css";
import { formatGBP } from "../../utils/currency";
type ContainerProps = {
  [x: string]: any;
};

const parties = ["Client", "Partner", "Joint"];
const periods = ["Monthly", "Annual"];

const OutgoingCalcTable = (props: ContainerProps) => {
  const values = props.OutgoingCalculationValues ?? {};
  return (
    <table className="income-calc-table">
      <thead>
        <tr>
          <th></th>
          {parties.map((party) => (
            <th key={party}>{party}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {periods.map((period) => (
          <tr key={period}>
            <th scope="row">{period}</th>
            {parties.map((party) => (
              <td key={party}>
                {formatGBP(values[`${period}${party}Amount`])}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default OutgoingCalcTable;
